import { getAvoidedCountries } from './getAvoidedCountries';

export const countriesOperations = {
  getAvoidedCountries
};
